<template>
  <section>
    <div class="columns mt-3">
      <div class="column hero-description is-half-desktop">
        <h1 class="pt-2 pb-5 is-size-3-mobile">
          {{ alternativeTitle ? alternativeTitle : $t("aokPlus.heroTitle") }}
        </h1>
        <p class="pt-2 pb-5 pr-7 hero-text is-size-4 is-size-5-mobile">
          {{ alternativeHeroText ? alternativeHeroText : $t("aokPlus.heroText") }}
        </p>
        <p class="mb-2 is-5 hero-text is-size-4">
          {{ $t("aokPlus.moreInfoAt") }}
        </p>
        <p class="mb-6 title is-4">0331 769 950 33</p>
        <div class="button-mobile-center-container is-flex">
          <a
            href="#aok-explanation"
            class="button is-brandpurple is-rounded is-outlined is-responsive has-text-centered-tablet"
          >
            {{ $t("aokPlus.learnMore") }}
          </a>
        </div>
      </div>
      <div
        class="column img_container is-half-desktop is-full-tablet is-centered is-flex is-justify-content-center ml-4 aok-plus-image-container"
      >
        <img class="image aok-plus-image" :src="imageUrl" :alt="$t('aokPlus.alt.logo')" />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "HealthInsuranceHero",
  props: {
    alternativeTitle: { type: String, default: null },
    alternativeHeroText: { type: String, default: null },
    alternativeImageName: { type: String, default: null },
  },
  computed: {
    imageUrl() {
      if (this.alternativeImageName === "mobil") {
        return "/images/health_insurances/mobil.svg"
      }
      if (this.alternativeImageName) {
        return `/images/health_insurances/${this.alternativeImageName}.png`
      }
      // defaulting to aok plus
      return "/images/health_insurances/aok_PLUS_logo.png"
    },
  },
}
</script>

<style scoped lang="scss">
.button-mobile-center-container {
  @media (max-width: $tablet) {
    justify-content: center;
  }
}

.img_container {
  display: flex;
  justify-content: center;

  img {
    max-height: 70%;
    display: flex;

    @media screen and (max-width: $desktop) {
      max-height: 200px;
    }
  }
}

.aok-plus-image {
  object-fit: contain;

  @media screen and (max-width: $tablet) {
    max-width: 320px;
  }

  @media screen and (max-width: $mobile) {
    max-width: 220px;
  }
}

section {
  margin-top: 24px;
  margin-bottom: 72px;

  @media screen and (min-width: $desktop) {
    margin-top: 64px;
  }
}
.hero-text {
  @media screen and (min-width: $desktop) {
    width: 70%;
  }
}
</style>
